// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "org_defaults".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "org_defaults" table (1:1 with a DB row, on the wire). */
export const orgDefaultsAtomSchema = z.object({
    organizationId: z.string(),
    adDailyBudgetCents: z.number().nullable(),
    adDailyBudgetCurrency: z.string().nullable(),
    adObjective: z.string().nullable(),
    adAreaType: z.string().nullable(),
    videoOrientation: z.string().nullable(),
    videoLengthSecs: z.number().nullable(),
    videoTemplateEngineV2: z.boolean(),
    brandVoice: z.string().nullable(),
    wageAutoClockIn: z.boolean().nullable(),
    wageAutoClockOut: z.boolean().nullable(),
    wageAutomatedBreaks: z.boolean().nullable(),
    wageLocationRestriction: z.boolean().nullable(),
    giftCardPresetAmounts: z.unknown().nullable(),
    giftCardExpiry: z.string().nullable(),
    resourceAssignmentMode: z.string().nullable(),
    defaultServiceIdForAds: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=orgDefaults.js.map